import React from 'react';
import BookHistoire from './BookHistoire';
import {useQuery} from "@tanstack/react-query";
import {FEATURE_STORIES_KEY, fetchHomeStories} from "../../../../../api/public-voissa/features";

const Book = () =>{
    const {isSuccess : isSuccessBook, isLoading : isLoadingBook, data : dataBook} = useQuery(
        [FEATURE_STORIES_KEY],
        ()=> fetchHomeStories(),
        {
            staleTime : (1000 * 60 * 5),
            placeholderData : {
                data : [],
            },
            select : (data) =>{
                return data.data || []
            }
        }
    );

    return (
        <div className="book">
            <div className="pages-wrapper">
                <div className="page left">
                    {isSuccessBook && !isLoadingBook && Array.isArray(dataBook) && dataBook.slice(0, 3).map(article => (
                        <BookHistoire key={article._id} {...article} />
                    ))}
                </div>
                <div className="page right">
                    {isSuccessBook && !isLoadingBook && Array.isArray(dataBook) && dataBook.slice(3, 6).map(article => (
                        <BookHistoire key={article._id} {...article} />
                    ))}
                </div>
            </div>
        </div>
    )
};

export default Book;